import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SendEventMerchantOrderFormLinksMutationVariables = Types.Exact<{
  input: Types.SendEventMerchantOrderFormLinksInput;
}>;


export type SendEventMerchantOrderFormLinksMutation = { __typename?: 'Mutation', sendEventMerchantOrderFormLinks: { __typename?: 'SendEventMerchantOrderFormLinksSuccess', sent_count: number, event_account_ids: Array<string> } | { __typename?: 'SendEventMerchantOrderFormLinksValidationError', error_code: string, message: string, invalid_event_account_ids?: Array<string> | null, not_participating_event_account_ids?: Array<string> | null, event_accounts_missing_email?: Array<{ __typename?: 'EventAccountMissingEmail', event_account_id: string, event_account_name?: string | null }> | null } };


export const SendEventMerchantOrderFormLinksDocument = gql`
    mutation SendEventMerchantOrderFormLinks($input: SendEventMerchantOrderFormLinksInput!) {
  sendEventMerchantOrderFormLinks(input: $input) {
    ... on SendEventMerchantOrderFormLinksSuccess {
      sent_count
      event_account_ids
    }
    ... on SendEventMerchantOrderFormLinksValidationError {
      error_code
      message
      event_accounts_missing_email {
        event_account_id
        event_account_name
      }
      invalid_event_account_ids
      not_participating_event_account_ids
    }
  }
}
    `;
export type SendEventMerchantOrderFormLinksMutationFn = Apollo.MutationFunction<SendEventMerchantOrderFormLinksMutation, SendEventMerchantOrderFormLinksMutationVariables>;

/**
 * __useSendEventMerchantOrderFormLinksMutation__
 *
 * To run a mutation, you first call `useSendEventMerchantOrderFormLinksMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendEventMerchantOrderFormLinksMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendEventMerchantOrderFormLinksMutation, { data, loading, error }] = useSendEventMerchantOrderFormLinksMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendEventMerchantOrderFormLinksMutation(baseOptions?: Apollo.MutationHookOptions<SendEventMerchantOrderFormLinksMutation, SendEventMerchantOrderFormLinksMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendEventMerchantOrderFormLinksMutation, SendEventMerchantOrderFormLinksMutationVariables>(SendEventMerchantOrderFormLinksDocument, options);
      }
export type SendEventMerchantOrderFormLinksMutationHookResult = ReturnType<typeof useSendEventMerchantOrderFormLinksMutation>;
export type SendEventMerchantOrderFormLinksMutationResult = Apollo.MutationResult<SendEventMerchantOrderFormLinksMutation>;
export type SendEventMerchantOrderFormLinksMutationOptions = Apollo.BaseMutationOptions<SendEventMerchantOrderFormLinksMutation, SendEventMerchantOrderFormLinksMutationVariables>;